import React, { useState } from 'react';
import './ProjectSnapshot.css';

const ProjectSnapshot = ({ url, title, className = "" }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    // Using microlink.io for free dynamic snapshots (no auth needed)
    const encodedUrl = encodeURIComponent(url);
    const snapshotUrl = `https://api.microlink.io/?url=${encodedUrl}&screenshot=true&meta=false&embed=screenshot.url`;

    return (
        <div className={`snapshot-container ${className}`}>
            {loading && !error && (
                <div className="snapshot-skeleton">
                    <div className="skeleton-shimmer"></div>
                    <span className="skeleton-text">Capturing Live View...</span>
                </div>
            )}
            {!error ? (
                <img
                    src={snapshotUrl}
                    alt={`${title} snapshot`}
                    className={`snapshot-img ${loading ? 'hidden' : 'fade-in'}`}
                    onLoad={() => setLoading(false)}
                    onError={() => {
                        setLoading(false);
                        setError(true);
                    }}
                />
            ) : (
                <div className="snapshot-error">
                    <span className="error-icon">🌐</span>
                    <h5 className="title__color">{title}</h5>
                    <p>Live preview unavailable</p>
                </div>
            )}
        </div>
    );
};

export default ProjectSnapshot;
